import React from 'react'
import Footer from '../../components/Footer/Footer';
import HomeCard from '../../components/HomeCard/HomeCard';
import banner2 from '../../assets/banner_2.svg'
import icon1 from '../../assets/icon1.jpg'
import icon2 from '../../assets/icon2.jpg'
import icon3 from '../../assets/icon3.jpg'
import { Link } from 'react-router-dom'
import styles from './Home.module.css';

const Home = () => {
    return (
        <div className={styles.container}>

            <div className={styles.bannerContainer}>
                <div className={styles.textContainer}>
                    <h2>Arrange Pickup <br />{"&"} Delivery</h2>
                    <p>Anything, Anytime, Anywhere...</p>
                </div>
                <img src={banner2} alt="banner" />
            </div>

            <div className={styles.cardsContainer}>
                <Link to="/pickup-location"><HomeCard img={icon1} /></Link>
                <Link to="/pickup-location"><HomeCard img={icon2} /></Link>
                <Link to="/pickup-location"><HomeCard img={icon3} /></Link>
            </div>

            {/* for later */}
            {/* <Ads /> */}

            <Footer />
        </div>
    )
}

export default Home
